import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceInterceptor } from '@core/service/interceptor.interceptor';
import { Modulo } from '@core/model/modulo.model';

@Injectable({
  providedIn: 'root'
})
export class ModuloService extends BaseAPIClass {
  constructor(protected httpClient: HttpClient, protected inter: ServiceInterceptor) {
    super(httpClient);
    this.baseUrl = '/modulos';
  }

  gethabilitado(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `/habilitados`);
  }

  getModuloByIdUser(userId: any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `/user/${userId}`);
  }

  getModuloAssignByIdUser(userId: any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `/usuario/${userId}`);
  }

  getModuloByIdArea(idArea: any): Observable<Modulo[]> {
    return this.httpClient.get<Modulo[]>(this.baseUrl + `/area/${idArea}`);
  }

  getModuloByCursoId(data: { curso_id: any; user_id: any }): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + `/curso`, data);
  }

  getModulosByCursoId(id: any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `/curso/${id}`);
  }

  getHabilitar(id: any) {
    return this.httpClient.get(this.baseUrl + `/habilitar/${id}`);
  }

  updateMudulo(id: string, formData: FormData) {
    return this.httpClient.post(this.baseUrl + '/' + id, formData);
  }

  getModulosByCurso(id: any): Observable<Modulo[]> {
    return this.httpClient.get<Modulo[]>(this.baseUrl + `/curso/${id}`);
  }
}
